import { Matrix, type Mesh } from "@babylonjs/core";

/** Matrices are the original ordinary instances' world matrices, not prototype-relative transforms. */
export function staticSceneryBatch(source: Mesh, name: string, matrices: readonly number[]): Mesh {
  const mesh = source.clone(name, null, true, false);
  // clone() can retain the source parent. A world-space buffer must not inherit either
  // that hierarchy or the source's local transform/pivot a second time.
  mesh.parent = null;
  mesh.position.setAll(0);
  mesh.rotation.setAll(0);
  mesh.rotationQuaternion = null;
  mesh.scaling.setAll(1);
  mesh.setPivotMatrix(Matrix.Identity());
  mesh.setEnabled(true);
  mesh.freezeWorldMatrix(Matrix.Identity());
  mesh.thinInstanceSetBuffer("matrix", new Float32Array(matrices), 16, true);
  mesh.thinInstanceRefreshBoundingInfo(false);
  return mesh;
}
